import { render, staticRenderFns } from "./ProposalPreDescription.vue?vue&type=template&id=699d0886&scoped=true&"
import script from "./ProposalPreDescription.vue?vue&type=script&lang=js&"
export * from "./ProposalPreDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProposalPreDescription.vue?vue&type=style&index=0&id=699d0886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d0886",
  null
  
)

export default component.exports